
import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Footer from '../../home/components/Footer';

export default function WartungPage() {
  const navigate = useNavigate();
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleRequestClick = () => {
    navigate('/');
    setTimeout(() => {
      const contactSection = document.getElementById('kontakt');
      if (contactSection) {
        contactSection.scrollIntoView({ behavior: 'smooth' });
        window.dispatchEvent(new CustomEvent('preselect-service', { detail: 'Wartung' }));
      }
    }, 100);
  };

  return (
    <div className="min-h-screen bg-white">
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-white shadow-md' : 'bg-transparent'}`}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-4 flex items-center justify-between">
          <Link to="/">
            <img src="https://public.readdy.ai/ai/img_res/cd59830a-a811-4b8c-95fb-12d94d035ec5.png" alt="Elektro Tomasevic KG" className="h-10 sm:h-12 w-auto" />
          </Link>
          <a href="tel:+436991223301" className="bg-[#F4B942] text-[#1A2B4A] px-4 sm:px-6 py-2.5 sm:py-3 rounded-full font-semibold hover:bg-[#e5a832] transition-colors cursor-pointer whitespace-nowrap text-sm sm:text-base">
            <i className="ri-phone-fill mr-1 sm:mr-2"></i>
            <span className="hidden sm:inline">+43 699 122 333 01</span>
            <span className="sm:hidden">Anrufen</span>
          </a>
        </div>
      </nav>

      <main className="pt-24 sm:pt-32 pb-16 sm:pb-24">
        <div className="max-w-4xl mx-auto px-4 sm:px-6">
          <Link
            to="/"
            onClick={(e) => {
              e.preventDefault();
              navigate('/');
              setTimeout(() => {
                const el = document.getElementById('leistungen');
                if (el) el.scrollIntoView({ behavior: 'smooth' });
              }, 100);
            }}
            className="inline-flex items-center text-[#1A2B4A] hover:text-[#F4B942] transition-colors mb-6 sm:mb-8 cursor-pointer text-sm sm:text-base"
          >
            <i className="ri-arrow-left-line mr-2"></i>
            Zurück zu allen Leistungen
          </Link>

          <div className="bg-gradient-to-br from-green-50 to-teal-50 rounded-3xl p-8 sm:p-12 mb-10 sm:mb-12">
            <div className="w-16 h-16 sm:w-20 sm:h-20 flex items-center justify-center bg-green-500 rounded-2xl mb-5 sm:mb-6">
              <i className="ri-tools-fill text-white text-3xl sm:text-4xl"></i>
            </div>
            <h1 className="text-3xl sm:text-5xl font-bold text-[#1A2B4A] mb-3 sm:mb-4">Elektro-Wartung &amp; Instandhaltung</h1>
            <p className="text-base sm:text-xl text-gray-600">
              Regelmäßige Wartung für Sicherheit, Effizienz und lange Lebensdauer Ihrer Elektroanlagen
            </p>
          </div>

          <div className="mb-10 sm:mb-12 space-y-4 sm:space-y-6">
            <p className="text-gray-700 leading-relaxed text-base sm:text-lg">
              Elektrische Anlagen und Geräte benötigen regelmäßige Wartung, um sicher und effizient zu funktionieren.
              Mit unserem professionellen Wartungsservice stellen wir sicher, dass Ihre Elektroinstallationen stets
              den aktuellen Sicherheitsstandards entsprechen und optimal arbeiten.
            </p>
            <p className="text-gray-700 leading-relaxed text-base sm:text-lg">
              Unser erfahrenes Team führt gründliche Inspektionen durch, identifiziert potenzielle Probleme frühzeitig
              und behebt sie, bevor sie zu ernsthaften Störungen führen.
            </p>

            <div className="bg-[#1A2B4A] rounded-2xl p-6 sm:p-8 text-white">
              <h3 className="text-xl sm:text-2xl font-bold mb-4 flex items-center">
                <i className="ri-checkbox-circle-fill text-[#F4B942] mr-3 text-2xl sm:text-3xl"></i>
                Unsere Wartungsleistungen im Überblick
              </h3>
              <ul className="space-y-3 text-white/90">
                {[
                  'Überprüfung und Wartung von Sicherungskästen und Verteilern',
                  'Kontrolle von FI-Schutzschaltern und Leitungsschutzschaltern',
                  'Inspektion von Steckdosen, Schaltern und Beleuchtungsanlagen',
                  'Wartung von Photovoltaik-Anlagen und Wechselrichtern',
                  'Prüfung von Alarmanlagen und Sicherheitssystemen',
                  'Thermografie zur Erkennung von Überhitzungen',
                  'Dokumentation aller Wartungsarbeiten und Prüfprotokolle',
                ].map((item, i) => (
                  <li key={i} className="flex items-start">
                    <i className="ri-arrow-right-s-fill text-[#F4B942] mr-3 mt-1 shrink-0"></i>
                    <span className="text-sm sm:text-base">{item}</span>
                  </li>
                ))}
              </ul>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6">
              {[
                { bg: 'bg-green-50', iconBg: 'bg-green-500', icon: 'ri-shield-check-fill', title: 'Mehr Sicherheit', desc: 'Regelmäßige Wartung minimiert das Risiko von Stromausfällen, Kurzschlüssen und Bränden.' },
                { bg: 'bg-teal-50', iconBg: 'bg-teal-500', icon: 'ri-money-euro-circle-fill', title: 'Kosten sparen', desc: 'Frühzeitige Problemerkennung verhindert teure Reparaturen und Produktionsausfälle.' },
                { bg: 'bg-cyan-50', iconBg: 'bg-cyan-500', icon: 'ri-time-fill', title: 'Längere Lebensdauer', desc: 'Gut gewartete Anlagen halten länger und arbeiten effizienter über viele Jahre.' },
                { bg: 'bg-emerald-50', iconBg: 'bg-emerald-500', icon: 'ri-file-list-3-fill', title: 'Rechtssicherheit', desc: 'Erfüllung aller gesetzlichen Prüfpflichten mit vollständiger Dokumentation.' },
              ].map((card, i) => (
                <div key={i} className={`${card.bg} rounded-xl p-5 sm:p-6`}>
                  <div className={`w-11 h-11 sm:w-12 sm:h-12 flex items-center justify-center ${card.iconBg} rounded-lg mb-3 sm:mb-4`}>
                    <i className={`${card.icon} text-white text-xl sm:text-2xl`}></i>
                  </div>
                  <h4 className="text-base sm:text-lg font-bold text-[#1A2B4A] mb-2">{card.title}</h4>
                  <p className="text-gray-600 text-sm">{card.desc}</p>
                </div>
              ))}
            </div>

            <p className="text-gray-700 leading-relaxed text-base sm:text-lg">
              Wir bieten flexible Wartungsintervalle an – ob jährlich, halbjährlich oder quartalsweise. Bei Abschluss
              eines Wartungsvertrags profitieren Sie von Preisnachlässen und bevorzugter Terminvergabe.
            </p>
          </div>

          <div className="bg-[#F8F9FB] rounded-2xl p-6 sm:p-8 text-center">
            <h3 className="text-xl sm:text-2xl font-bold text-[#1A2B4A] mb-3 sm:mb-4">Wartungsvertrag anfragen</h3>
            <p className="text-gray-600 mb-5 sm:mb-6 text-sm sm:text-base">
              Sichern Sie sich jetzt einen individuellen Wartungsvertrag und profitieren Sie von unseren Vorteilen.
            </p>
            <button
              onClick={handleRequestClick}
              className="inline-flex items-center justify-center w-full sm:w-auto bg-[#F4B942] text-[#1A2B4A] px-6 sm:px-8 py-4 rounded-xl font-bold text-base hover:bg-[#e5a832] transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-mail-send-fill mr-2"></i>
              Jetzt Anfrage senden
            </button>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
